import { REDUX } from 'constants/'
import {
  GlobalReducerTypeInitiator,
  GlobalAction,
  GlobalReducer
} from 'types/global'
/**
 * Reducer para objeto global
 * @param state 
 * @param action 
 */
const GlobalReducers = (state = GlobalReducerTypeInitiator, action: GlobalAction): GlobalReducer => {
  switch (action.type) {
    case REDUX.reducers.SHOW_LOADING:
      return { ...state, data: action.payload, error: false, loading: true } as GlobalReducer
    case REDUX.reducers.HIDE_LOADING:
      return { ...state, data: action.payload, error: false, loading: false } as GlobalReducer
    default:
      return state
  }
}

export default GlobalReducers